import { Global, ThemeProvider } from '@emotion/react';
import { useAppState } from '@providers/AppStateProvider';
import MeetingProviderWithDeviceReplacement from '@providers/MeetingProviderWithDeviceReplacement';
import { VoiceFocusProvider } from '@providers/VoiceFocusProvider';
import { globalStyle } from '@styles/global';
import type { VoiceFocusModelName } from 'amazon-chime-sdk-js';
import { type FC, type PropsWithChildren } from 'react';
import { BrowserRouter } from 'react-router';

const AppLayout: FC<PropsWithChildren> = ({ children }) => {
  const { joinInfo } = useAppState();

  function voiceFocusName(name: string): VoiceFocusModelName {
    if (name && ['default', 'ns_es'].includes(name)) {
      return name as VoiceFocusModelName;
    }
    return 'default';
  }

  function getVoiceFocusSpecName(): VoiceFocusModelName {
    return voiceFocusName('default');
  }

  const vfConfigValue = {
    spec: { name: getVoiceFocusSpecName() },
    createMeetingResponse: joinInfo,
  };

  return (
    <BrowserRouter>
      <ThemeProvider theme={{}}>
        <Global styles={globalStyle} />
        <VoiceFocusProvider {...vfConfigValue}>
          <MeetingProviderWithDeviceReplacement>
            {children}
          </MeetingProviderWithDeviceReplacement>
        </VoiceFocusProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default AppLayout;
